<!-- Localized -->
<template>
  <div
    class="timeline"
    :class="{
      'timeline--wrap': rowWrap,
    }"
    data-testid="versions-timeline-container"
    ref="container"
  >
    <div
      v-for="(point, idx) in computedList"
      :key="point.id"
      class="timeline__item"
      :class="{
        'cursor-pointer': !readonly,
      }"
      ref="pointData"
      @click="selectPoint(point)"
    >
      <div
        class="point text-gray-600 text-xs"
        ref="pointContainer"
      >
        <div
          class="point__content-wrapper"
          :class="{
            'point__content-wrapper--current text-primary': checkCurrent(point),
          }"
          :style="{
            width: pointWidth + 'px',
            height: pointWidth + 'px',
          }"
          ref="pointContent"
        >

          <font-awesome-icon
            v-if=" !checkCurrent(point)"
            class="point__content point__content--passed text-primary-content"
            icon="check"
          />
          <div
            v-else-if="checkCurrent(point)"
            class="point__content point__content--current text-success"
          />
          <div
            v-else
            class="point__content point__content--default text-primary-content"
          >
            {{ idx + 1 }}
          </div>
        </div>

        <div class="flex flex-col items-center">
          <label :for="point.id" class="point__label cursor-pointer">{{ point.date }}</label>
          <input
            :checked="checkCurrent(point)"
            type="checkbox"
            :disabled="readonly"
            :id="point.id"
            class="checkbox cursor-pointer checkbox-primary border-box-stroke checkbox-sm flex mt-1"
            @click="($event) => handleCheckBoxClick($event, point)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VersionsTimeline",

  props: {
    /**
     * @typedef {Object} Point
     * @property {number} id
     * @property {string} [label]
     */
    /**
     * @type {Point[]}
     */
    list: {
      type: Array,
      required: true,
    },
    rowWrap: {
      type: Boolean,
      default: false,
    },
    disableCheckboxHandler: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    pointWidth: {
      type: Number,
      default: 20,
    },
  },

  computed: {
    computedList() {
      return this.list ?? [];
    },
  },

  methods: {
    selectPoint(point) {
      if (!this.readonly)
        this.$emit('select', point)
    },
    checkCurrent(point) {
      return this.list.find((el) => el.current)?.current === point.current;
    },
    handleCheckBoxClick(e, point) {
      if (this.disableCheckboxHandler && !point.current) {
        e.preventDefault();
        e.stopPropagation();
        this.$emit('select', point);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/functions.scss';

* {
  box-sizing: border-box;
}

.timeline {
  position: relative;
  display: flex;
  justify-content: flex-start;
  gap: 30px;

  &--wrap {
    flex-wrap: wrap;
  }

  &__item {
    display: inline-flex;
    flex-direction: column;
    align-items: center;

    .point {
      position: relative;
      z-index: 10;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      gap: toRem(4px);

      &__content-wrapper {
        position: relative;
        border-radius: 50%;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border: toRem(2px) solid currentColor;

        &--passed {
          padding: toRem(3px);
        }

        &--current {
          //background: none;
          padding: toRem(2px);
        }
      }

      &__content {
        width: 10px;
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: toRem(10px);
        &--current {
          border-radius: 50%;
          background-color: currentColor;
        }
      }

      &__icon {
        border-radius: 50%;
        background-color: currentColor;
        border: 5px solid currentColor;
      }

      &__line {
        width: 0;
        height: 3px;
        background-color: currentColor;
        position: absolute;
        top: 50%;
        left: 100%;
      }

      &__line--main {
        height: 3px;
        width: 100%;
        left: 0;
      }

      &__label {
        font-weight: normal;
        font-size: toRem(12px);
        line-height: 1.1;
        white-space: nowrap;
        min-width: toRem(80px);
        text-align: center;
      }
    }
  }
}
</style>
